import React from 'react';
import Reflux from 'reflux';
import './ModalAlert.css';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from 'react-google-login';
import {ModalContainer, ModalDialog} from 'react-modal-dialog';
import AppActions from '../AppActions';
import ModalActions from '../actions/ModalActions';
import ModalStore from '../stores/ModalStore';
import AppStore from '../AppStore';
import RcIf from 'rc-if';
import WheelLoader from '../components/wheelloader/WheelLoader';

class ModalAlert extends Reflux.Component {
    constructor (props) {
        super(props);
        this.stores = [ModalStore, AppStore];
    }
    handleClose () {
        ModalActions.changeModalLoginStatus(false);
    }
    responseFacebook (response) {
        let user = response;
        AppActions.loginUserFacebook(user);
    }
    responseGoogle = (response) => {
        AppActions.loginUserGoogle(response);
    }
    responseGoogleError = (err) => {
        console.error('google error', err);
    }
    render () {
        return (
          <RcIf if={this.state.isModalLoginShowing}>
            <ModalContainer className='modalLoginTotal' onClose={this.handleClose}>
              <ModalDialog className='modalLoginContainer' onClose={this.handleClose}>
                <div className='topLogin'>
                  <h5>Ingresar con</h5>
                </div>
                <h4>Conéctate con una red social</h4>
                <ul className='list-social'>
                  <li>
                    <FacebookLogin
                      appId={process.env.REACT_APP_FB_APP_ID}
                      fields='name,email,picture'
                      tag='a'
                      disableMobileRedirect
                      cssClass='fb-btn'
                      textButton='FACEBOOK'
                      icon={<span><i className='fa fa-facebook' aria-hidden='true' /></span>}
                      callback={this.responseFacebook} />
                  </li>
                  <li className='relative'>
                    <span className='icon-login-btn'><i className='fa fa-google' /></span>
                    <GoogleLogin clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID} tag='a' className='btn-google' onSuccess={this.responseGoogle} onFailure={this.responseGoogleError} buttonText='GOOGLE' />
                  </li>
                </ul>
                <RcIf if={this.state.loadingLogin}>
                  <WheelLoader />
                </RcIf>
                <p className='conditions'>Ingresar nos indica que has leído y aceptado los <span>términos y condiciones</span></p>
              </ModalDialog>
            </ModalContainer>
          </RcIf>
        );
    }
}
export default ModalAlert;



// WEBPACK FOOTER //
// ./src/sections/ModalAlert.js